<script>
    import InvalidInputIcon from "$lib/InvalidInputIcon.svelte";

    export let message = "Invalid Sign In";
</script>

<div class="container">
    <InvalidInputIcon/>
    <div class="message">
        {message}
    </div>
</div>

<style lang="scss">
  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0 9px;
  }

  .message {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    /* Light coral chosen over --color-background-dark-red (#DC4942) which only
       reaches ~3.6:1 on the #262B46 login background and fails WCAG AA at 14px.
       #FF8A8A lands at ~5.5:1 on #262B46 and ~6.6:1 on the #0E1D44 accents,
       while staying in the red family so it still reads as an error. */
    color: #FF8A8A;
  }
</style>